var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlayStore = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  id: "play-store_svg__a",
  width: 800,
  height: 800,
  viewBox: "0 0 48 48"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".play-store_svg__b{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M25.027 24.052 8.765 39.885h0C9.285 41.65 10.945 43 12.918 43q1.245 0 2.18-.623h0l18.17-10.279z",
  className: "play-store_svg__b"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "m40.95 20.262-7.786-4.464-8.137 8.254 8.24 8.046 7.788-4.36c1.35-.727 2.284-2.18 2.284-3.738-.104-1.558-1.038-3.011-2.388-3.738ZM8.765 8.115c-.104.311-.104.727-.104 1.142v29.59c0 .415 0 .727.104 1.142l16.262-15.937z",
  className: "play-store_svg__b"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "m25.027 24.052 8.137-8.254L15.202 5.623C14.58 5.208 13.75 5 12.918 5 10.945 5 9.18 6.35 8.765 8.115h0z",
  className: "play-store_svg__b"
})));
export default SvgPlayStore;